import { Grid, TextField } from "@material-ui/core";
import { forwardRef, useImperativeHandle } from "react";
import { useForm, Controller } from "react-hook-form";
import { Autocomplete } from "@material-ui/lab";

const userRoles = [
  { title: "تایید نشده", id: "not_verified" },
  { title: "کاربر", id: "user" },
  { title: "کاربر بدون دسترسی عمومی", id: "global_limited_user" },
  { title: "فقط مشاهده", id: "read_only" },
];

const UserRoleForm = forwardRef((props, ref) => {
  const { onSubmitForm, defaultValues, loading = false } = props;

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues ?? null,
  });

  useImperativeHandle(ref, () => ({
    submit: () => handleSubmit(onSubmitForm)(),
  }));

  return (
    <form onSubmit={handleSubmit(onSubmitForm)}>
      <Grid container direction='row' spacing={1}>
        <Grid item xs={12}>
          <Controller
            name='role'
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={userRoles}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='نوع کاربر'
                    size='small'
                    variant='outlined'
                    margin='dense'
                    fullWidth
                    error={errors.role}
                    helperText={errors.role && "فیلد نمیتواند خالی باشد"}
                  />
                )}
                getOptionLabel={(option) => option?.title}
                onChange={(_, data) => field.onChange(data)}
              />
            )}
          />
        </Grid>
      </Grid>
    </form>
  );
});

export default UserRoleForm;
